import React from "react";
import {WithdrawalTab} from "../withdrawal-tab";
import {PayoutSettingsTab} from "../payout-settings-tab";
import {TransactionSettingsTabFetchWrapper} from "../transaction-settings-tab";

type TPayoutPageTabsData = {tab: string; key: string; content: React.ReactNode}[];

export const PayoutPageTabsData: TPayoutPageTabsData = [
  {
    tab: "Withdrawal",
    key: "withdrawal",
    content: <WithdrawalTab />,
  },
  {
    tab: "Payout settings",
    key: "payout",
    content: <PayoutSettingsTab />,
  },
  {
    tab: "Transaction fee settings",
    key: "transaction",
    content: <TransactionSettingsTabFetchWrapper />,
  },
];
